import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { PlantLogo } from '../types/plant-logo.type';

@Injectable({
  providedIn: 'root',
})
export class PlantLogoService {
  constructor(private http: HttpClient) {}

  getPlantLogos() {
    return this.http.get<PlantLogo[]>(
      `${environment.apiBaseUrl}services/fluxmasterdata/api/plant/logos`,
    );
  }
}
